export function useConsentCookie () {
  return useCookie<boolean>( "a-consent-status", {
    maxAge: 365 * 24 * 60 * 60,
  } );
}
